import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'SelectAgreements',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default,
    filterDataComp: require('../../../../customcontrols/filterData.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appKey: 0,
      keyColumn: 'agreement.agreemNo',
      agreements: [],
      currentAgreements: [],
      typeSelected: [],
      statusSelected: [],
      typeSelectedDefault: [],
      statusSelectedDefault: [],
      agreementNumbersSelected: [],
      message: '',
      lang: '',
      agreemCols: [],
      readOnly: false,
      noDataFound: false,
      options: { pageSize: 1000, total: 0, page: 1 },
      totalRow: 0,

      showSelectedPanel: false,
      filterObj: [],

      installmentsDialogVisability: false,
      installments: []
    };
  },
  computed: {
    isAgreementSelected: function () {
      return this.currentAgreements.length > 0;
    }
  },
  watch: {},
  created() {
    this.$root.$on('select_agreements_updated', () => {
      console.log('select agreements updated', this.dataObj);
      this.getAgreements();
    });
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appKey = this.dataObj.appKey;
        this.fillFiltersObj();
        //this.getAgreements();

        for (var i = 0; i < this.dataObj.currentAgreements.length; i++) {
          this.dataObj.agreementIds.push(this.dataObj.currentAgreements[i].agreement.agreemNo);
        }
      });
    },

    getAgreements() {
      var agreeTypes = [];
      var agreeStatus = [];

      for (var i = 0; i < this.filterObj.filter((a) => a.added).length; i++) {
        if (this.filterObj.filter((a) => a.added)[i].field == 'AgreementTypes') {
          for (var v = 0; v < this.filterObj.filter((a) => a.added)[i].value.length; v++) {
            var t = this.dataObj.agreementTypes.filter((p) => p.value == this.filterObj.filter((a) => a.added)[i].value[v])[0];
            t.selected = true;
            agreeTypes.push(t);
          }
        } else if (this.filterObj.filter((a) => a.added)[i].field == 'AgreementStatuses') {
          for (var v = 0; v < this.filterObj.filter((a) => a.added)[i].value.length; v++) {
            var t = this.dataObj.agreementStatuses.filter((p) => p.value == this.filterObj.filter((a) => a.added)[i].value[v])[0];
            t.selected = true;
            agreeStatus.push(t);
          }
        }
      }

      var criteria = {
        AgreementTypes: agreeTypes,
        AgreementStatuses: agreeStatus
      };

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: this.dataObj.appKey,
        Item: criteria
      };

      console.log('parameter', parameter);

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectAgreementsActivity/GetAgreements', parameter),
        (response) => {
          if (response.status == 200) {
            if (response.data.items.length == 0) {
              this.agreements = [];
              this.noDataFound = true;
              this.dataObj.agreementIds = [];
            } else {
              this.agreements = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
            }
            this.$root.$emit('datagrid_updated');
          }
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text)
      );
    },
    fillFiltersObj() {
      //for (var v = 0; v < this.dataObj.agreementTypes.filter(a => a.selected).length; v++) {
      //  var t = this.dataObj.agreementTypes.filter(p => p.selected)[v];
      //  this.typeSelectedDefault.push(t.value);
      //}

      for (var v = 0; v < this.dataObj.agreementTypes.length; v++) {
        var t = this.dataObj.agreementTypes[v];
        t.selected = true;
        this.typeSelectedDefault.push(t.value);
      }

      for (var v = 0; v < this.dataObj.agreementStatuses.filter((a) => a.selected).length; v++) {
        var t = this.dataObj.agreementStatuses.filter((p) => p.selected)[v];
        this.statusSelectedDefault.push(t.value);
      }

      this.typeSelected = this.typeSelectedDefault;
      this.statusSelected = this.statusSelectedDefault;

      this.filterObj.push({
        defaultIndex: 0,
        index: 0,
        field: 'AgreementTypes',
        fieldDesc: this.$t('activities.agreementType'),
        type: 'list',
        listSource: this.dataObj.agreementTypes,
        listValueField: 'value',
        listTextField: 'text',
        multipleSelect: true,
        addedDefault: true,
        defaultValue: this.typeSelectedDefault,
        value: this.typeSelected,
        added: true
      });

      this.filterObj.push({
        defaultIndex: 1,
        index: 1,
        field: 'AgreementStatuses',
        fieldDesc: this.$t('activities.agreementStatus'),
        type: 'list',
        listSource: this.dataObj.agreementStatuses,
        listValueField: 'value',
        listTextField: 'text',
        multipleSelect: true,
        addedDefault: true,
        defaultValue: this.statusSelectedDefault,
        value: this.statusSelected,
        added: true
      });
    },
    showInstallments(index) {
      this.installments = this.agreements[index].installments;
      this.installmentsDialogVisability = true;
    }
  }
};
